import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    selectedOutcome: null,
    nextRoutePath: null,
    contributions: {
      current: null,
      goal: null,
    },
  },
  mutations: {
    setContributions(state, payload) {
      state.contributions = payload;
    },
    setSelectedOutcome(state, payload) {
      state.selectedOutcome = payload;

      let primaryColorFaded = payload
        ? payload.primaryColor
          ? payload.primaryColor.split("#")
          : ["", "162c47"]
        : "#162c47";
      let primaryColorFadedString = "#" + primaryColorFaded[1] + "80";

      document.documentElement.style.setProperty(
        "--outcome-primary",
        payload && payload.primaryColor ? payload.primaryColor : "#162c47"
      );
      document.documentElement.style.setProperty(
        "--outcome-secondary",
        payload && payload.secondaryColor ? payload.secondaryColor : "#162c47"
      );
      document.documentElement.style.setProperty(
        "--outcome-tertiary",
        payload && payload.tertiaryColor ? payload.tertiaryColor : "#162c47"
      );
      document.documentElement.style.setProperty(
        "--outcome-primary-faded",
        primaryColorFadedString
      );
    },
    setNextRoutePath(state, payload) {
      state.nextRoutePath = payload;
    },
  },
  actions: {
    loadAll: async ({ commit }) => {
      let contributionData = await api.get(`general/settings`);
      commit("setContributions", contributionData.data.contributions);
    },

    updateSelectedOutcome: async ({ commit }, payload) => {
      commit("setSelectedOutcome", payload);
    },

    save: async ({ dispatch }, formData) => {
      await api.put(`general/settings`, formData);
      dispatch("loadAll");
    },
  },
  getters: {
    contributions(state) {
      return state.contributions;
    },
    selectedOutcome(state) {
      return state.selectedOutcome;
    },
    nextRoutePath(state) {
      return state.nextRoutePath;
    },
  },
};
